import { forwardRef, useEffect, useRef, useState } from 'react';

// Small stand-ins for the shadcn dropdown / popover / button the Lovable design uses, with the same classes.
export const BTN_BASE = 'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium cursor-pointer transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 disabled:cursor-not-allowed [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0';
export const BTN_VARIANT = {
  default: 'bg-primary text-primary-foreground shadow hover:bg-primary/90',
  outline: 'border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground',
  secondary: 'bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80',
  ghost: 'hover:bg-accent hover:text-accent-foreground',
};
export const BTN_SIZE = { default: 'h-9 px-4 py-2', sm: 'h-8 rounded-md px-3 text-xs', icon: 'h-9 w-9' };

export const Button = forwardRef(function Button({ variant = 'default', size = 'default', className = '', type = 'button', ...props }, ref) {
  return <button ref={ref} type={type} className={`${BTN_BASE} ${BTN_VARIANT[variant]} ${BTN_SIZE[size]} ${className}`} {...props} />;
});

// A trigger plus a panel anchored under it (right-aligned). Closes on outside click and Escape.
export function Popover({ trigger, children, panelClassName = '', label, open: controlled, onOpenChange }) {
  const [inner, setInner] = useState(false);
  const open = controlled != null ? controlled : inner;
  const setOpen = (v) => { if (onOpenChange) onOpenChange(v); if (controlled == null) setInner(v); };
  const box = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    const onDoc = (e) => { if (box.current && !box.current.contains(e.target)) setOpen(false); };
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', onDoc);
    document.addEventListener('keydown', onKey);
    return () => { document.removeEventListener('mousedown', onDoc); document.removeEventListener('keydown', onKey); };
  }, [open]);
  return (
    <div className="relative" ref={box}>
      {trigger({ open, toggle: () => setOpen(!open) })}
      {open && (
        <div role="dialog" aria-label={label} className={`absolute right-0 top-full z-50 mt-1 rounded-md border bg-popover text-popover-foreground shadow-md animate-in fade-in-0 zoom-in-95 ${panelClassName}`}>
          {typeof children === 'function' ? children({ close: () => setOpen(false) }) : children}
        </div>
      )}
    </div>
  );
}

export const MENU_ITEM = 'relative flex w-full cursor-pointer select-none items-center gap-2 rounded-sm px-2 py-1.5 text-left text-sm outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground [&>svg]:size-4 [&>svg]:shrink-0';
